import { render } from "./Home5.vue?vue&type=template&id=60219728"
import script from "./Home5.vue?vue&type=script&lang=js"
export * from "./Home5.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__